const MERCHANT_TYPE = {
    subscriber: 'subscriber',
    nonSubscriber: 'non_subscriber',
    passenger: 'passenger'
};

const MERCHANT_TYPE_LABEL = {
    subscriber: 'abonné',
    non_subscriber: 'non abonné',
    passenger: 'passager'
};

export { MERCHANT_TYPE, MERCHANT_TYPE_LABEL };
